<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="当事人:" prop="dwmc">
                        <el-input
                        v-model="queryParams.dwmc"
                        placeholder="请输入当事人"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="立案日期:" prop="lianRq">
                        <el-date-picker size="small"
                            v-model="queryParams.lianRq"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            @clear="handleClear('lianRq')"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="检查日期:" prop="jianchaRq">
                        <el-date-picker size="small"
                            v-model="queryParams.jianchaRq"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            @clear="handleClear('jianchaRq')"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="决定日期:" prop="jdsRq">
                        <el-date-picker size="small"
                            v-model="queryParams.jdsRq"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                @clear="handleClear('jdsRq')"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结案日期:" prop="jieanRq">
                        <el-date-picker size="small"
                            v-model="queryParams.jieanRq"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                            @clear="handleClear('jieanRq')"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <!-- <el-form-item label="" label-width="0">
                        <el-checkbox v-model="checked">包含个人</el-checkbox>
                    </el-form-item>
                    <el-form-item label="关键词:" prop="gjc">
                        <el-input
                        v-model="queryParams.gjc"
                        placeholder="请输入关键词"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="企业性质:" prop="qyxz">
                        <el-input
                        v-model="queryParams.qyxz"
                        placeholder="请输入企业性质"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item label="专业类别:" prop="zylb">
                        <el-select v-model="queryParams.zylb" placeholder="请选择专业类别" size="small">
                            <el-option
                                v-for="dict in zylbOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="案件分类:" prop="ajfl">
                        <el-select v-model="queryParams.ajfl" placeholder="请选择案件分类" size="small">
                            <el-option
                                v-for="dict in ajflOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="审批状态:" prop="spzt">
                        <el-select v-model="queryParams.spzt" placeholder="请选择审批状态" size="small">
                            <el-option
                                v-for="dict in spztOptions"
                                :key="dict.ID"
                                :label="dict.mc"
                                :value="dict.ID"
                                ></el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
                <!-- ，简易程序:0件 
                <p style="width: calc(100% - 160px); line-height: 20px;">案件数量:{{total}}件(其中一般程序:0件；处罚法定代表人:0家（罚款金额:0元），负责人:0家（罚款金额:0元），经营者:0家（罚款金额:0元）， 个人:0家（罚款金额:0元）)，罚款金额总计:元，没收违法所得:元。
                </p>-->
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="ajslList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="决定书文号" align="center" prop="jdswh" />
                    <el-table-column label="监督对象名称" prop="dwmc" />
                    <el-table-column label="专业类别" align="center" prop="zylb" />
                    <el-table-column label="案由" prop="reason2" />
                    <el-table-column label="立案日期" align="center" prop="lianRq" >
                        <template slot-scope="scope">
                            <span v-if="scope.row.lianRq">{{ getDate(scope.row.lianRq,'yyyy-MM-dd') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="检查日期" align="center" prop="jianchaRq"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.jianchaRq">{{ getDate(scope.row.jianchaRq,'yyyy-MM-dd') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="送达日期" align="center" prop="songdaDate"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.songdaDate">{{ getDate(scope.row.songdaDate,'yyyy-MM-dd') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="履行日期" align="center" prop="lvxingRq"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.lvxingRq">{{ getDate(scope.row.lvxingRq,'yyyy-MM-dd') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="决定日期" align="center" prop="jdsRq"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.jdsRq">{{ getDate(scope.row.jdsRq,'yyyy-MM-dd') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="结案日期" align="center" prop="jieanRq"  >
                        <template slot-scope="scope">
                            <span v-if="scope.row.jieanRq">{{ getDate(scope.row.jieanRq,'yyyy-MM-dd') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="创建人" align="center" prop="hostMan" />
                    <el-table-column label="警告、罚款" align="center" prop="chufazhonglei" />
                    <el-table-column label="罚款金额" align="center" prop="fakuan" />
                    <el-table-column label="测评得分" align="center" prop="gzsno4" />
                    <!--<el-table-column label="查看" align="center" class-name="small-padding fixed-width" width="220" >
                        <template slot-scope="scope">
                            <el-button
                            size="small"
                            type="text"
                            @click="handleShow(scope.row)"
                        >查看</el-button>
                        </template>
                    </el-table-column>-->
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>

        <el-dialog title="决策分析" :visible.sync="open" top="5vh" width="90%" append-to-body :close-on-click-modal="false" class="pcTk">
            
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            xm1:'',
            sj1:'',
            xm2:'',
            sj2:'',
            cmid:'',
            dm:'',
            queryParams:{
                dwmc:'',
                jianchaRq: [],
                lianRq: [],
                jdsRq: [],
                jieanRq: [],
                gjz:'',
                qyxz:'',
                zylb:'',
                spzt:'',
                ajfl:'',
                page:1,
                limit:10,
            },
            total:0,
            checked:false,
            ajslList:[],
            zylbOptions:[],
            ajflOptions:[],
            spztOptions:[],
            checkList:[],
            open:false,
            pageshow:true,
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.cmid = user.c_mid
        this.baseUrl = user.baseUrl

        axios({
            method: 'post',
            url: this.baseUrl+`/login/getZylb`,
            data:{
                 "cfxt":""
            },
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zylbOptions = res.data.data
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        this.getList()
    },
    methods: {
        handleClear(dateField) {
            this.queryParams[dateField] = [];
            console.log(this.queryParams[dateField])
        },
        getList(){
            this.ajslList = []
            this.total = 0
            this.loading = true
            axios({
                method: 'post',
                url: this.baseUrl+`/pdfApi/getjuecefenxi`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    dwmc:this.queryParams.dwmc,
                    cmid:this.cmid,
                    jianchaRq:this.queryParams.jianchaRq ? this.queryParams.jianchaRq : [],
                    lianRq:this.queryParams.lianRq ? this.queryParams.lianRq : [],
                    jdsRq:this.queryParams.jdsRq ? this.queryParams.jdsRq : [],
                    jieanRq:this.queryParams.jieanRq ? this.queryParams.jieanRq : [],
                    pageSize:this.queryParams.limit,
                    pageNum:this.queryParams.page
                }
            })
            .then(response => {
                console.log(response.data);
                this.ajslList = response.data.data.list
                this.total = response.data.data.total || 0
                this.loading = false
            })
            .catch(error => {
                this.loading = false
                console.error('There was an error!', error);
            });
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){},
        handleShow(row){
            //this.open = true;
            //this.row = row;
        },
        resetQuery(){
            this.queryParams = {
                dwmc:'',
                lianRq: [],
                jianchaRq: [],
                jdsRq: [],
                jieanRq: [],
                gjz:'',
                qyxz:'',
                zylb:'',
                spzt:'',
                ajfl:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
    }
}
</script>


<style scoped>
</style>